import logo from './logo.svg';
// import './App.css';
import { Route, Routes, Link } from "react-router-dom"
import Home from "./Home";
function App() {
  return (
    <div className="App">
      <Routes>
          <Route exact path="/" element={<Home />}></Route>
        </Routes>
    </div>
  );
}

export default App;
